import React from "react";
import { AddCircleOutline, Cancel } from "@mui/icons-material";
import { CurrencyInputField, InputField } from "components/form";
import { useFormContext, useFieldArray, useWatch } from "react-hook-form";
import { Typography, Box, Button, Stack, IconButton, Tooltip } from "@mui/material";
import { TotalSumOfSection } from "./TotalSumOfSection";
import { QuoteArrayFieldsProps, QuoteFormValues } from "../../../types";

export const RebatesSection = ({ equipmentId = null }: QuoteArrayFieldsProps) => {
  const { control } = useFormContext<QuoteFormValues>();
  const { fields, append, remove } = useFieldArray({ control, name: "rebates" });
  const rebates = useWatch({ control, name: "rebates" });

  const handleAddCustomFee = () => {
    append({ amount: 0, description: "", equipmentId });
  };

  return (
    <Box className="quoteSection">
      <Typography variant="h6" component="span">
        Rebates
      </Typography>

      {!!fields.length && (
        <Box className="arrFields">
          {fields.map(({ id }, index) => (
            <Box key={id} className="arrField">
              <Stack direction="row" alignItems="center">
                <Typography>Rebate #{index + 1}</Typography>
                <Tooltip title="Remove Rebate">
                  <IconButton
                    size="small"
                    onClick={() => {
                      remove(index);
                    }}>
                    <Cancel color="error" fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Stack>

              <Box className="quoteFields">
                <CurrencyInputField label="Amount" control={control} name={`rebates.${index}.amount`} />

                <InputField
                  control={control}
                  label="Description"
                  name={`rebates.${index}.description`}
                  inputProps={{
                    placeholder: "Enter description ...",
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Stack direction="row" gap="1rem" justifyContent="space-between" alignItems="center">
        <Button size="small" startIcon={<AddCircleOutline />} onClick={handleAddCustomFee}>
          Add
        </Button>

        <TotalSumOfSection values={rebates} calcKey="amount" />
      </Stack>
    </Box>
  );
};
